import Carousel from './carousel';
import './carousel.scss';

export default Carousel;
